import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"

const EmbedVideo = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="p-3 flex items-center justify-center" 
      dangerouslySetInnerHTML={{__html: blok.iframeCode}} />
  )
}

export default EmbedVideo
